/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Vyberte možnosti`
};

const da_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Vælg muligheder`
};

const de_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Optionen auswählen`
};

const en_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Select options`
};

const es_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Elegir opciones`
};

const fr_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Choisir des options`
};

const hu_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Lehetőségek kiválasztása`
};

const it_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Scegli opzioni`
};

const nl_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Kies opties`
};

const pl_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Wybierz opcje`
};

const pt_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Escolher opções`
};

const sv_select_options = /** @type {(inputs: {}) => string} */ () => {
	return `Välj alternativ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const select_options = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.select_options(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("select_options", locale)
	if (locale === "cs") return cs_select_options(inputs)
	if (locale === "da") return da_select_options(inputs)
	if (locale === "de") return de_select_options(inputs)
	if (locale === "en") return en_select_options(inputs)
	if (locale === "es") return es_select_options(inputs)
	if (locale === "fr") return fr_select_options(inputs)
	if (locale === "hu") return hu_select_options(inputs)
	if (locale === "it") return it_select_options(inputs)
	if (locale === "nl") return nl_select_options(inputs)
	if (locale === "pl") return pl_select_options(inputs)
	if (locale === "pt") return pt_select_options(inputs)
	return sv_select_options(inputs)
};